import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'components/ErrorPage';
import { Helmet } from 'react-helmet';

import Sidebar from 'Workspace/components/WorkspaceSidebar';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';

import {
  PageWrapper,
  PageViewport,
} from 'components/PageStyles';

export default function PlaceholderPage({ pageTitle, selectedNavKey, ...props }) {
  return (
    <PageWrapper>
      <Helmet>
        <title>{props.title}</title>
        {!!props.message && <meta name="description" content={props.message} />}
      </Helmet>
      <Sidebar navigation={<HomeNavigation selectedKey={selectedNavKey} />} />
      <PageViewport style={{ position: 'relative' }}>
        <ErrorPage {...props} />
        <WorkspaceHeader title={pageTitle} />
      </PageViewport>
      <HelpMenu />
    </PageWrapper>
  );
}

PlaceholderPage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  pageTitle: PropTypes.string,
  selectedNavKey: PropTypes.string,
};
